import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import {
    Button,
    Grid
} from '@material-ui/core';
import axios from 'axios';
import Common from '../Common';

const styles = () => ({
    displayFlex: {
        display: 'flex'
    },
    verticalSpace: {
        margin: '10px 20px 20px 150px',
    },
    searchButtonSpace: {
        margin: '10px 0px 10px 10px',
    }
});

const CreateButton = withCookies((props) => {
    const {
        classes,
        cookies,
        categoryName,
        memoRequired,
        note,
        nameObj
    } = props;
    const [update, setUpdata]= React.useState(false);

    const postData = () => {
        let errAlert = '';
        if(categoryName.trim() === ''){
            if(errAlert !== '') errAlert += '\n';
            errAlert += `「${nameObj.KUBUN_NAME}」を入力して下さい。`;
        }
        if(note.trim() === '' && memoRequired){
            if(errAlert !== '') errAlert += '\n';
            errAlert += `「${nameObj.BIKO_NAME}」を入力して下さい。`;
        }
        if(errAlert !== ''){
            window.alert(errAlert);
            return;
        }
        const token = cookies.get('token');
        const jichitaiToken = cookies.get('x-jichitai-token');
        const jichitaiId = cookies.get('x-jichitai-jichitaiid');
        const supportedPersonId = cookies.get('supportedPersonId');
        axios.get(
            `${Common.apiServerUrl()}/api/counseling/getCounselingKubun`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {},
            }
        )
        .then(Common.handleErrors)
        .then((res) => {
            if (res.success) {
                const duplicateArray = res.counselingKubunArray.filter((d) => d.counselingKubunName === categoryName);
                if(duplicateArray.length > 0){
                    window.alert('入力された名前は既に使用されています。');
                    return;
                }
                else{
                    const confirm = window.confirm(`「${categoryName}」を作成しますか？`);
                    if(confirm){
                        axios.post(
                            `${Common.apiServerUrl()}/api/counseling/kubun`,
                            {
                                supportedPersonId,
                                categoryName,
                                note
                            },
                            {
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                    'x-suppportcenter-token': token,
                                    'x-jichitai-jichitaiid': jichitaiId,
                                    'x-jichitai-token': jichitaiToken,
                                },
                            }
                        )
                        .then(Common.handleErrors)
                        .then((response) => {
                            if (response.success) {
                                window.alert(`「${categoryName}」の作成に成功しました。`);
                                setUpdata(update ? false : true);
                                window.location.href = '/category';
                                return;
                            } else {
                                window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                            }
                        })
                        .catch((err) => {
                            console.error('CreateButton.js postData:post err:' + err);
                        });
                    }
                }
            } else {
                window.alert(`code : [${res.type}]\nmessage : ${res.message}`);
            }
        })
        .catch((err) => {
            console.error('CreateButton.js postData:get err:' + err);
        });
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button color="primary" size="large" className={classes.searchButtonSpace} variant="contained" onClick={() => postData()}>作成</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
});

CreateButton.propTypes = {
    classes: PropTypes.object.isRequired,
    categoryName: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    cookies: PropTypes.object.isRequired,
    memo: PropTypes.string.isRequired,
    memoRequired: PropTypes.bool.isRequired,
    nameObj: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateButton);